module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-UltLt.6cfe401a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNextLTPro-UltLt.woff
// module id = 229
// module chunks = 0